import { Component, EventEmitter, Input, input, Output, ViewChild } from '@angular/core'
import { CourtSystemWithMetadata } from '@ftr/contracts/api/court-system'
import { Uuid } from '@ftr/contracts/type/shared'
import { featureFlag } from '@ftr/ui-feature-flags'
import {
  BranchNavItem,
  COURT_SYSTEM_NAV_ITEMS,
  PUBLIC_COURT_SYSTEM_NAV_ITEMS,
  SideNavDisplayMode,
  SideNavGroup,
  SideNavItem,
} from '../../navigation/side-nav-item'
import { CourtSystemDropdownComponent } from '../court-system-dropdown/court-system-dropdown.component'
import { SideNavShellComponent } from '../side-nav-shell/side-nav-shell.component'

@Component({
  selector: 'ftr-courts-side-nav-display',
  templateUrl: './courts-side-nav-display.component.html',
  imports: [SideNavShellComponent, CourtSystemDropdownComponent],
})
export class CourtsSideNavDisplayComponent {
  protected publicNavigationEnabled = featureFlag('public-navigation')

  @Input() displayMode: SideNavDisplayMode = 'DEFAULT'
  @Input() expanded: boolean = true
  @Input() isLoading: boolean = false
  @Input() currentCourtSystemId: Uuid | undefined
  @Input() isOpened: boolean
  @Output() sideBarToggled = new EventEmitter<void>()
  @Output() expandedToggled = new EventEmitter<void>()

  navGroups = input([] as SideNavGroup[])
  footerItems = input([] as SideNavItem[])
  @ViewChild(SideNavShellComponent) private shell: SideNavShellComponent

  onCourtSystemDropdownOpened(courtSystem?: CourtSystemWithMetadata): void {
    const publicNav = this.publicNavigationEnabled()
    const title = courtSystem ? courtSystem.name : 'For The Record'
    const courtSystemNavItems = courtSystem ? COURT_SYSTEM_NAV_ITEMS : COURT_SYSTEM_NAV_ITEMS.slice(0, 1)
    const children = publicNav ? PUBLIC_COURT_SYSTEM_NAV_ITEMS : courtSystemNavItems
    this.shell.openBranchNav({ type: 'BRANCH', title, children } as BranchNavItem)
  }
}
